import styles from "./ProductsGroupCard.module.scss";

export const ProductsGroupCard = ({ productImg, productName, onClick }) => {
  return (
    <div className={styles.productsContainer} onClick={onClick}>
      <div className={styles.productsWrapper}>
        <img
          src={productImg}
          className={styles.productsWrapper__img}
          alt="productImg"
        />
        <div className={styles.productsWrapper__title}>
          <p>{productName}</p>
        </div>
      </div>
    </div>
  );
};
